<template>
  <div class="AuthInfoPageView view">
    <Error404 />
  </div>
</template>

<script>
import store from '@/store';
import Error404 from '@/components/Common/Error404';

export default {
  name: 'AuthInfoPage',
  store,
  components: { Error404 },
};
</script>



// WEBPACK FOOTER //
// src/views/AuthInfoPage.vue